import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { paths } from "../generated-types";

type FrozenStatusOperation = paths["/dashboard/synota/contracts/frozen-status"]["post"];
export type UseFrozenStatusInput =
  FrozenStatusOperation["requestBody"]["content"]["application/json"];

export const useFrozenStatus = (input?: UseFrozenStatusInput) => {
  const { client } = useHttp();

  const queryKey = ["frozen-status", input];

  const { status, isPending, isFetching, data, error, refetch } = useAxiosQuery<string | null>({
    queryKey,
    queryFn: ({ signal }) => client.post("/synota/contracts/frozen-status", input, { signal }),
    enabled: Boolean(input && input.user_email),
  });

  return {
    frozenUntil: data?.data || null,
    status,
    isPending,
    isFetching,
    error,
    refetch,
    queryKey,
  };
};

export type UseFrozenStatusReturn = ReturnType<typeof useFrozenStatus>;
